// Firebase Config — Single source of truth (public client identifiers, not secrets)
export const firebaseConfig = {
  apiKey: 'AIzaSyA8QVREY05IDMyEH0vSyS6S13Q6leYb33s',
  authDomain: 'app.chancen-pilot.de',
  projectId: 'teamflow-d358e',
  storageBucket: 'teamflow-d358e.firebasestorage.app',
  messagingSenderId: '166455159329',
  appId: '1:166455159329:web:ad44a8cff2f30a1aff5160',
};
